import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/settings/settings.service';
import { TranslatorService } from '../../../core/translator/translator.service';
import { AuthService, Roles, LoginStatus } from "../../../shared/authentication/auth.service";
import { User } from "../../users/user";
import { TranslateService } from 'ng2-translate/ng2-translate';
import {ModalDirective} from "ng2-bootstrap/index";
import {UsersService} from "../../users/users/users.service";


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

    @ViewChild('selectOrgModal') bsModal: ModalDirective;

    me: User;
    errorMessage: string;
    valForm: FormGroup;

    showError = false;
    inProgress = false;

    constructor(
          public settings: SettingsService,
          private authService: AuthService,
          private usersService: UsersService,
          private translatorService: TranslatorService,
          private router: Router,
          private translate: TranslateService,
          fb: FormBuilder
        ) {

        this.valForm = fb.group({
            'id': [null, Validators.required],
            'password': [null, Validators.required]
        });
    }

    setLanguage() {
        let availableLangs = this.translate.getLangs();
        let browserLang = this.translate.getBrowserCultureLang();
        if(availableLangs.indexOf(browserLang) != -1) {
            this.translatorService.useLanguage(browserLang);
        } else {
            this.translatorService.useLanguage(this.translatorService.getCurrentLanguage());
        }
    }

    submitForm($ev, value: any) {
        $ev.preventDefault();
        for (let c in this.valForm.controls) {
            this.valForm.controls[c].markAsTouched();
        }
        if (this.valForm.valid) {
            this.inProgress = true;
            this.authService.login(this.valForm.value.id, this.valForm.value.password)
                .toPromise()
                .then(result => {
                    this.inProgress = false;
                    this.showError = false;
                    if (result.result == LoginStatus.OK_PENDING_ORG) {
                        this.me = result.me;
                        this.showSelectOrganizationModal();
                    } else {
                        this.getUserInfo();
                    }
                }).catch(error => {
                    this.inProgress = false;
                    this.errorMessage = <any>error;
                    this.showError = true;
                });
        }
    }

    getUserInfo() {
        this.usersService.getUsersMe()
            .toPromise()
            .then( me => {
                this.me = me;
                if (!this.authService.getSelectedOrg() && me.organizations[0]._organization) {
                    this.authService.setSelectedOrg(me.organizations[0]._organization._id);
                }
                this.authService.setUser(this.me);
                if (me.organizations[0].role === Roles.UBERADMIN) {
                    this.router.navigate(['/uberadmin/home']);
                } else {
                    this.router.navigate(['/admin/dashboard']);
                }
            });
    }

    showSelectOrganizationModal() {
        this.bsModal.show();
    }

    selectOrganization(organization) {
        this.authService.setSelectedOrg(organization._organization._id);

        this.authService.login(this.valForm.value.id, this.valForm.value.password, organization._organization._id)
            .toPromise()
            .then(result => {
                this.inProgress = false;
                this.showError = false;
                this.getUserInfo();
            }).catch(error => {
                this.inProgress = false;
                this.errorMessage = <any>error;
                this.showError = true;
            });
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.translate.setDefaultLang('en');
        this.setLanguage();
    }
}



// WEBPACK FOOTER //
// ./src/app/routes/pages/login/login.component.ts